import { MERCH } from "../data/content";
import { GarmentCard } from "./GarmentCard";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Merch = () => (
    <section className="pt-28 md:pt-44" data-testid="merch-section">
        <SectionHeading index="04" title="Merch" id="merch" />

        <div className="px-6 md:px-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 md:gap-x-8 gap-y-16 items-start">
            {MERCH.map((item, i) => (
                <GarmentCard key={item.id} item={item} delay={(i % 4) * 0.08} />
            ))}
        </div>

        <Reveal className="mt-20 md:mt-32">
            <figure data-testid="merch-band-figure">
                <div className="overflow-hidden">
                    <img
                        src="/assets/models-full.jpg"
                        alt="Three models wearing the capsule garments in a dark studio with reflective floor"
                        loading="lazy"
                        decoding="async"
                        className="poster-img w-full h-auto"
                        data-testid="merch-band-image"
                    />
                </div>
                <figcaption className="mt-4 px-6 md:px-12 font-mono2 text-[9px] md:text-[10px] tracking-[0.25em] text-[var(--mute)] uppercase">
                    <span>Worn</span>
                </figcaption>
            </figure>
        </Reveal>
    </section>
);
